module.exports = __webpack_public_path__ + "static/media/slash.decb466e.svg";